export default "__VITE_ASSET__ed98611a__"